import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Response } from '@angular/http';
import { ClientModel } from '../../shared/models/client.model';
import { OauthService } from '../../shared/services/oauth.service';
import { PointsService } from '../../shared/services/points.service';

/**
 * Points balance card shown at the account pages. Renders NOTHING unless the
 * store gate (`points-program-enabled` at storeConfigurations) is on AND the
 * API confirms `enabled` — a store without the program stays identical.
 */
@Component({
    selector: 'account-points-summary',
    templateUrl: './account.points-summary.component.html',
    styleUrls: ['./../account.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class AccountPointsSummaryComponent implements OnInit {
    public show = false;
    public loading = false;
    public balance = 0;
    public balanceCurrency = 0;
    public pending = 0;
    public nextReleasePoints = 0;
    public nextReleaseAt: string = null;
    public expiringPoints = 0;
    public expiringAt: string = null;

    private gateOn = false;

    constructor(
        protected oauth: OauthService,
        protected points: PointsService,
        protected activatedRoute: ActivatedRoute
    ) {
        this.oauth.loadedAuthenticatedUser$.subscribe((client: ClientModel) => {
            this.load(client);
        });
    }

    ngOnInit() {
        const data = this.activatedRoute.snapshot.data;
        const configurations = data['storeConfigurations'] || {};
        this.gateOn = !!(+configurations['points-program-enabled'] || false);
    }

    private load(client: ClientModel) {
        if (!this.gateOn || !client || !client.id) {
            return;
        }

        this.loading = true;
        this.points.summary(+client.id).subscribe((response: Response) => {
            const data = response.json().data;
            this.loading = false;

            if (!data['enabled']) {
                return; // backend says off: render nothing
            }

            this.balance = data['balance'];
            this.balanceCurrency = data['balance_currency'];
            this.pending = data['pending'];
            if (data['next_release']) {
                this.nextReleasePoints = data['next_release']['points'];
                this.nextReleaseAt = data['next_release']['release_at'];
            }
            if (data['expiring']) {
                this.expiringPoints = data['expiring']['points'];
                this.expiringAt = data['expiring']['expires_at'];
            }
            this.show = true;
        }, () => {
            this.loading = false; // any API error: render nothing, never break the page
        });
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src1143190010/src/src/app/account/points/account.points-summary.component.ts